import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { SearchAreasList } from '../components/ui/SearchAreasList';
import { PrinciplesList } from '../components/ui/PrinciplesList';
import { ProcessSteps } from '../components/ui/ProcessSteps';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CallToAction } from '../components/ui/CallToAction';
import { images } from '../data/images';
import { boardConsiderations, boardDifferences } from '../data/boardConsiderations';
import { discussSearchHref } from '../data/navigation';
export function LeadershipBoardSearch() {
  usePageMeta('Leadership & Board Search | Avenqor Talent Search', 'Executive, C-suite, board and non-executive director search, including committee expertise, governance, risk and compliance leadership.');
  return <>
      <PageHero eyebrow="Leadership & Board Search" title="Board, non-executive and C-suite search." intro="Appointments at the top of an organization carry strategic, governance and reputational weight. We approach them with additional rigour, discretion and care." data-id="element-506" data-mp="i4mnjsmem1p">
        <ButtonLink to={discussSearchHref} variant="gold" data-id="element-507" data-mp="3088v92mvi0wa">
          Discuss a Board Search
        </ButtonLink>
      </PageHero>

      <div className="bg-navy" data-id="element-508" data-mp="3a43hs8u7wg4c">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-509" data-mp="3a30ra20t4foy">
          <img src={images.boardroomEmpty.src} alt={images.boardroomEmpty.alt} loading="lazy" className="aspect-[16/9] w-full object-cover md:aspect-[21/8]" data-id="element-510" data-mp="3558xt3kiklin" />
        </div>
      </div>

      <section className="bg-white" aria-labelledby="difference-title" data-id="element-511" data-mp="3e78ji96h4drx">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-32" data-id="element-512" data-mp="1oqh7cw6xhobz">
          <div className="lg:col-span-4" data-id="element-513" data-mp="1jsfrek4su54q">
            <SectionHeading id="difference-title" eyebrow="Why It Differs" title="Board search is its own discipline." data-id="element-514" data-mp="1jtqsgc6v0ys5" />
          </div>
          <ul className="border-b border-line lg:col-span-7 lg:col-start-6" data-id="element-515" data-mp="3ot8j1vzaoxa8">
            {boardDifferences.map(item => <li key={item.title} className="border-t border-line py-8" data-id="element-516" data-mp="3ts3d5u2pq89n">
                <h3 className="font-serif text-[1.65rem] font-medium leading-tight text-navy" data-id="element-517" data-mp="1oang8tgtxpa">{item.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-518" data-mp="6o5f4el2erbe">{item.text}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-navy" aria-labelledby="capabilities-title" data-id="element-519" data-mp="bkdn980uhk92">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-32" data-id="element-520" data-mp="gdynl6pwuqbf">
          <div className="lg:col-span-4" data-id="element-521" data-mp="lc08zyat71q2">
            <SectionHeading id="capabilities-title" eyebrow="Search Capabilities" title="Where we search." onDark intro="The areas of leadership and board expertise our search work is designed to cover." data-id="element-522" data-mp="peepibr09pe6" />
          </div>
          <div className="lg:col-span-7 lg:col-start-6" data-id="element-523" data-mp="29wfes5oc4o4w">
            <SearchAreasList onDark data-id="element-524" data-mp="29uuncoxbhlb9" />
          </div>
        </div>
      </section>

      <section className="bg-white" aria-labelledby="considerations-title" data-id="element-525" data-mp="25vdgbr28sg3z">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-526" data-mp="20w98b3r20of8">
          <SectionHeading id="considerations-title" eyebrow="Board Considerations" title="What we weigh in every board appointment." data-id="element-527" data-mp="2xlqi9ux2kwmq" />
          <div className="mt-16" data-id="element-528" data-mp="2tmittzkpmwb4">
            <PrinciplesList items={boardConsiderations} columns={4} data-id="element-529" data-mp="2oswoksgvlupc" />
          </div>
        </div>
      </section>

      <section className="bg-paper" aria-labelledby="board-process-title" data-id="element-530" data-mp="2jtaeut09awla">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-531" data-mp="3h9hb2zgnm8a3">
          <SectionHeading id="board-process-title" eyebrow="Our Approach" title="The same discipline, applied at board level." data-id="element-532" data-mp="3hbk8w5o1t5pd" />
          <div className="mt-16" data-id="element-533" data-mp="2w1yiw7sm39y3">
            <ProcessSteps showDetail data-id="element-534" data-mp="312l47iu8zr7u" />
          </div>
        </div>
      </section>

      <CallToAction title="Planning a Board or Leadership Appointment?" text="We would welcome a confidential conversation with your chair, nominations committee or leadership team." data-id="element-535" data-mp="310i5maf14pri" />
    </>;
}